import { Link, useLocation } from '@tanstack/react-router';
import { useState } from 'react';
import { useSamePageNavigation } from '@/hooks/useSamePageNavigation';
import { tw } from '@/lib/tailwind';
import { DashboardNavigationItem } from '@/types/';
import SubNav from '../../SubNav/SubNav';
import { PreloadOption } from '@/types/navigation';

interface ThoughtSpotNavigationItemProps {
  label: string;
  link: string;
  className?: string;
  params: Record<string, string>;
  subnav?: DashboardNavigationItem[];
  preload?: PreloadOption;
}

export default function ThoughtSpotNavigationItem({
  label,
  link,
  params,
  subnav,
  preload,
}: ThoughtSpotNavigationItemProps) {
  const { isCurrentPage } = useSamePageNavigation();
  const routerLocation = useLocation();
  const isActivePage = link.replace('$page', params.page) === routerLocation.pathname;
  const [isSubNavOpen, setIsSubNavOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsSubNavOpen(true);
  };

  const handleMouseLeave = () => {
    setIsSubNavOpen(false);
  };

  return (
    <div
      className={tw(
        `group hover:border-background-400 hover:bg-background-100 transition-colors`,
        `relative z-20 flex items-center gap-0.5`,
        `border-b border-solid px-2.5 py-2`,
        `${isActivePage ? 'border-background-400' : 'border-transparent'}`,
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link
        params={params}
        to={link}
        search={isCurrentPage(link, params ?? {}) ? { reload: new Date().getTime() } : {}}
        preload={preload}
      >
        {label}
      </Link>
      {subnav && (
        <SubNav
          page={params.page}
          subnav={subnav}
          isSubNavOpen={isSubNavOpen}
          setIsSubNavOpen={setIsSubNavOpen}
        />
      )}
    </div>
  );
}
